/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_Gridcraft_Online_Sections_2_Figure_CaptionInputs */

const en_gc_search_guides_gridcraft_online_sections_2_figure_caption = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_2_Figure_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`After reopening, check objects such as charts as well as cell values. Screenshot: ArtCraft.`)
};

const zh_gc_search_guides_gridcraft_online_sections_2_figure_caption = /** @type {(inputs: Gc_Search_Guides_Gridcraft_Online_Sections_2_Figure_CaptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`重新打开后，除了单元格数值，也要检查图表等对象。截图来源：ArtCraft。`)
};

/**
* | output |
* | --- |
* | "After reopening, check objects such as charts as well as cell values. Screenshot: ArtCraft." |
*
* @param {Gc_Search_Guides_Gridcraft_Online_Sections_2_Figure_CaptionInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_gridcraft_online_sections_2_figure_caption = /** @type {((inputs?: Gc_Search_Guides_Gridcraft_Online_Sections_2_Figure_CaptionInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_Gridcraft_Online_Sections_2_Figure_CaptionInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_gridcraft_online_sections_2_figure_caption(inputs)
	return zh_gc_search_guides_gridcraft_online_sections_2_figure_caption(inputs)
});
export { gc_search_guides_gridcraft_online_sections_2_figure_caption as "gc.search_guides.gridcraft_online.sections.2.figure.caption" }